import { pushRAID, setRAIDInput, storeRAID } from 'raid-js';

const logRAID = () => {
  storeRAID();
  pushRAID();
  setRAIDInput();
};

export default logRAID;
